import React from "react"

const Tag = ({ name = "hello" }) => (
  <div className="tag-wrapper">
    <div className="tag-name">{name}</div>
  </div>
)

export default Tag
